angular.module('nv.SchoolMetricsModule').component('regentsMetrics', {
  template: require('./views/regents-table.html'),
  bindings: {
    currentSchool: '<',
  },
  controller: 'RegentsMetricsCtrl',
});
